import { localizationUtils } from '../../../../shared/utils';
import resources from './locales';

import ContactInformation from './ContactInformation';

const { withLocalization } = localizationUtils;

export default withLocalization(
  ContactInformation,
  resources,
  'ContactInformation'
);
